import clsx from "clsx";
import { useEffect, useState } from "react";
// 
/*
checked: boolean | any;
  className?: string;
  readonly?: boolean;
  id?: string;
  name?: string;*/
interface ToggleProps extends React.InputHTMLAttributes<HTMLInputElement>{
  readonly?: boolean;
}
export default function Toggle({
  checked,
  className,
  readonly = false,
  ...rest
 
}: ToggleProps) {
  const [localValue, setLocalValue] = useState(checked || false);
  useEffect(() => {
    setLocalValue(checked || false);
  }, [checked]);
  const handleChange = () => {
    if (readonly) return;
    setLocalValue(!localValue);
  };
  //console.log({localValue})
  return (
    <div
      onClick={handleChange}
      className={clsx(
        `relative inline-flex cursor-pointer h-6 w-11 items-center rounded-full border-2 border-gray-300  transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`,
        className,
        {
          "bg-purple-400 focus:ring-offset-gray-100": localValue == true,
          "bg-gray-200 focus:ring-offset-gray-200": localValue == false,
          "cursor-not-allowed opacity-70": readonly,
        }
      )}
    >
      <span
        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
          localValue ? "translate-x-5" : "translate-x-0"
        }`}
      />

      <input
      {...rest}
      style={{ display: "none" }}
        type="checkbox"
        checked={localValue}
        readOnly={readonly}
        onChange={() => null}
      ></input>
    </div>
  );
}
